import api from '@/api';
import i18n from '@/i18n';
import utilities from '@/helpers/utilities';

const state = {
    isLoggedIn: !!localStorage.getItem('gds_prodam'),
    profile: JSON.parse(localStorage.getItem('gds_prodam')) || {},
};

const mutations = {
    login(state, profile) {
        if (utilities.isEmpty(profile.person)) profile.person = { id: 0 };

        // Copy CAC data to profile
        profile.person.name = profile.name;
        profile.person.username = profile.login;
        state.isLoggedIn = true;
        state.profile = profile;
        state.profile.isAdmin = profile.person.isAdmin;
        state.profile.isRoot = profile.person.isRoot;
        state.profile.isHired = profile.person.isHired;
        localStorage.setItem('gds_prodam', JSON.stringify(profile));
    },
    logout(state) {
        state.isLoggedIn = false;
        state.profile = {};
        localStorage.removeItem('gds_prodam');
    },
    updateProfile(state, person) {
        state.profile.isNew = false;
        state.profile.person = person;
    },
};

const actions = {
    async login({ commit, dispatch }, credentials) {
        const response = await api.auth.authenticate(credentials);
        commit('login', response.data);
    },
    async changePassword({ dispatch }, credentials) {
        await api.auth.changePassword(credentials);
        dispatch('showSuccess', i18n.t('message.success.passwordUpdated'));
    },
    logout({ commit, dispatch }) {
        dispatch('reset');
        commit('logout');
    },
    updateProfile({ commit }, person) {
        commit('updateProfile', person);
    },
};

const getters = {
    isAdmin(state) {
        return state.profile.isAdmin;
    },
    isFirstLogin(state) {
        return state.profile.isNew;
    },
    isLoggedIn(state) {
        return state.isLoggedIn;
    },
    isPersonUpdateRequired(state, getters) {
        return !getters.isFirstLogin && state.profile.person.isUpdateRequired;
    },
    profile(state) {
        return state.profile;
    },
    roles(state) {
        if (!state.profile) return [];
        const roles = state.profile.roles || [];

        return roles.reduce((map, obj) => {
            map[obj] = true;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/modules/auth.js